// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__77re-","close-button":"styles_close-button__zlVvx","closeButton":"styles_close-button__zlVvx"};